var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agreement)?_c('agreement-renderer',{ref:"AgreementRenderer",attrs:{"agreement":_vm.agreement,"signer":_vm.signer,"show-finish-warning":_vm.showWarning},on:{"finalize":_vm.submitFinalized}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }